import React, { useEffect } from 'react';
import { Navbar } from '../components/sales/Navbar';
import { HeroSection } from '../components/sales/HeroSection';
import { HeadlineStackSection } from '../components/sales/HeadlineStackSection';
import { PainSection } from '../components/sales/PainSection';
import { ReframeSection } from '../components/sales/ReframeSection';
import { ProductRevealSection } from '../components/sales/ProductRevealSection';
import { FeaturesSection } from '../components/sales/FeaturesSection';
import { TestimonialsSection } from '../components/sales/TestimonialsSection';
import { FinalCTASection } from '../components/sales/FinalCTASection';
import { Footer } from '../components/sales/Footer';
export function SalesPage() {
  useEffect(() => {
    // Fire Meta Pixel PageView on load
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-background text-primary font-sans [&::selection]:bg-accent-yellow [&::selection]:text-background" data-id="element-214">
      <div className="grain-overlay" data-id="element-215"></div>
      <Navbar data-id="element-216" />
      <main data-id="element-217">
        <HeroSection data-id="element-218" />
        <HeadlineStackSection data-id="element-219" />
        <PainSection data-id="element-220" />
        <ReframeSection data-id="element-221" />
        <ProductRevealSection data-id="element-222" />
        <FeaturesSection data-id="element-223" />
        <TestimonialsSection data-id="element-224" />
        <FinalCTASection data-id="element-225" />
      </main>
      <Footer data-id="element-226" />
    </div>;
}